import { getMerchantByID } from "@/api/admin";

const initialState = {
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  merchants: [],
  merchantsLoadState: null, // null | "loading" | "loaded" | "empty" | "error"
  selectedMerchant: null,
  selectedLocation: null,
  locationSelectorOpened: false,
  changePasswordModalOpen: false,
  currentRole: [],
  toasts: [],
  mainContainer: null,
  idScans: [],
  dashboardActionCounts: { idScanReview: 0, prospect: 0 },
  vpnRequired: false,
  vpnConnected: false,
  mfaSetupRequired: false,
  showDemoModal: false,
  isDemoUser: false,
  prospect_conversion_id: null,
  onboard_steps: null,
  mainScrollContainer: null,
};

const getRole = (permissions, selectedMerchant, selectedLocation) => {
  if (!permissions) return [];
  for (let i = 0; i < permissions.length; i++) {
    if (permissions[i].merchant === selectedMerchant) {
      for (let j = 0; j < permissions[i].locations?.length; j++) {
        if (permissions[i].locations[j].location === selectedLocation) {
          return permissions[i].locations[j].permissions;
        }
      }
    }
  }
  return [];
};
const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MAIN_CONTAINER":
      return {
        ...state,
        mainContainer: action.payload,
      };
    case "SET_MAIN_SCROLL_CONTAINER":
      return {
        ...state,
        mainScrollContainer: action.payload,
      };
    case "SET_ID_SCANS":
      return {
        ...state,
        idScans: action.payload,
      };
    case "SET_DASHBOARD_ACTION_COUNTS":
      return {
        ...state,
        dashboardActionCounts: action.payload,
      };
    case "SET_MERCHANTS_LOAD_STATE":
      return {
        ...state,
        merchantsLoadState: action.payload,
      };
    case "SET_CHANGE_PASSWORD_MODAL_OPEN":
      return {
        ...state,
        changePasswordModalOpen: action.payload,
      };
    case "ADD_TOAST":
      return {
        ...state,
        toasts: [...state.toasts, action.payload],
      };
    case "REMOVE_TOAST":
      return {
        ...state,
        toasts: state.toasts.filter((toast) => toast.id !== action.payload),
      };
    case "REMOVE_ALL_TOAST":
      return {
        ...state,
        toasts: [],
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        user: action.payload.user,
        isAuthenticated: true,
        loading: false,
        changePasswordModalOpen: action.payload.f,
      };
    case "LOGIN_PARTIAL_SUCCESS":
      return {
        ...state,
        user: action.payload.user,
        isAuthenticated: false, // Not fully authenticated until MFA is set up
        loading: false,
        changePasswordModalOpen: action.payload.f,
      };
    case "LOGOUT":
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        vpnRequired: false,
        vpnConnected: false,
        mfaSetupRequired: false,
        showDemoModal: false,
        isDemoUser: false,
        merchants: [],
        merchantsLoadState: null,
        selectedMerchant: null,
        selectedLocation: null,
        currentRole: [],
        prospect_conversion_id: null,
        idScans: [],
        dashboardActionCounts: { idScanReview: 0, prospect: 0 },
      };
    case "SET_MERCHANTS":
      if(action.payload !== null){
        let selectedMerchant = action.payload[0];
        if (localStorage.getItem("selectedMerchant")) {
          const foundMerchant = action.payload.find(
            (loc) => loc.id === localStorage.getItem("selectedMerchant")
          );
          if (foundMerchant) selectedMerchant = foundMerchant;
        }
        localStorage.setItem("selectedMerchant", selectedMerchant.id);
        let selectedLocation = selectedMerchant.locations?.[0];
        if (selectedLocation) {
          const selectedLocationKey = `selectedLocation:${selectedMerchant.id}`;
          if (localStorage.getItem(selectedLocationKey)) {
            const foundLocation = selectedMerchant.locations?.find(
              (loc) => loc.id === localStorage.getItem(selectedLocationKey)
            );
            if (foundLocation) selectedLocation = foundLocation;
          }
          localStorage.setItem(
            `selectedLocation:${selectedMerchant.id}`,
            selectedLocation.id
          );
          localStorage.setItem(
            `selectedLocationStoreId:${selectedMerchant.id}`,
            selectedLocation.store_id
          );
        }
        return {
          ...state,
          merchants: action.payload,
          currentRole: getRole(
            state.user.permissions,
            selectedMerchant?.id,
            selectedLocation?.id
          ),
          selectedMerchant,
          selectedLocation,
          merchantsLoadState: "loaded",
        };
      }else{
        return {
          ...state,
          merchants: [],
          selectedMerchant: null,
          selectedLocation: null,
          currentRole: [],
          merchantsLoadState: "empty",
        }
      }
      

      

    case "SET_SELECTED_MERCHANT": {
      let merchant = action.payload;
      localStorage.setItem("selectedMerchant", merchant.id);
      
      let location = merchant.locations?.[0];
      if (localStorage.getItem(`selectedLocation:${merchant.id}`)) {
        const foundLocation = merchant.locations?.find(
          (loc) =>
            loc.id === localStorage.getItem(`selectedLocation:${merchant.id}`)
        );
        if (foundLocation) location = foundLocation;
      }
      localStorage.setItem(`selectedLocation:${merchant.id}`, location.id);
      localStorage.setItem(
        `selectedLocationStoreId:${merchant.id}`,
        location.store_id
      );
      window.dashboardBoardcastChannel.postMessage({
        type: "merchantChange",
        merchant: merchant.id,
      });
      return {
        ...state,
        currentRole: getRole(state.user.permissions, merchant.id, location.id),
        selectedMerchant: merchant,
        selectedLocation: location,
      };
    }
    case "SET_SELECTED_LOCATION":
      localStorage.setItem(
        `selectedLocation:${state.selectedMerchant.id}`,
        action.payload
      );
      const location = state.selectedMerchant.locations.find(
        (loc) => loc.id === action.payload
      );
      localStorage.setItem(
        `selectedLocationStoreId:${state.selectedMerchant.id}`,
        location.store_id
      );
      window.dashboardBoardcastChannel.postMessage({
        type: "locationChange",
        location: action.payload,
      });
      return {
        ...state,
        currentRole: getRole(
          state.user.permissions,
          state.selectedMerchant.id,
          location.id
        ),
        selectedLocation: location,
      };
    case "SET_LOCATION_SELECTOR_OPENED":
      return {
        ...state,
        locationSelectorOpened: action.payload,
      };
    case "UPDATE_USER_PERMISSIONS":
      return {
        ...state,
        user: {
          ...state.user,
          permissions: action.payload,
        },
        currentRole: getRole(
          action.payload,
          state.selectedMerchant?.id,
          state.selectedLocation?.id
        ),
      };
    case "FILTER_MERCHANTS_BY_ROLE":
      return {
        ...state,
        merchants: action.payload,
      };
    case "UPDATE_CURRENT_ROLE":
      return {
        ...state,
        currentRole: action.payload,
      };
    case "UPDATE_USER_TYPE":
      return {
        ...state,
        user: {
          ...state.user,
          type: action.payload,
        },
      };
    case "SET_VPN_REQUIRED":
      return {
        ...state,
        vpnRequired: action.payload,
      };
    case "SET_VPN_CONNECTED":
      return {
        ...state,
        vpnConnected: action.payload,
      };
    case "SET_MFA_SETUP_REQUIRED":
      return {
        ...state,
        mfaSetupRequired: action.payload,
      };
    case "SET_DEMO_MODAL_SHOW":
      return {
        ...state,
        showDemoModal: action.payload,
      };
    case "SET_IS_DEMO_USER":
      return {
        ...state,
        isDemoUser: action.payload,
      };
    case "SET_PROSPECT_CONVERSION_ID":
      return {
        ...state,
        prospect_conversion_id: action.payload,
      };
    case "SET_ONBOARD_STEPS":
      return {
        ...state,
        onboard_steps: action.payload,
      };
    default:
      return state;
  }
};

export default appReducer;
